import React, { useState } from "react";
import useRegistrationInfo from "../../../hooks/useRegistrationInfo";
import { useTranslation } from "react-i18next";

function AddRegistration({
  conditions,
  setIsUpLoading,
  addRegi,
  setAddRegi,
  schoolYear,
  userData,
  allSortedRows,
  flexibleData,
}) {
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [genderBirth, setGenderBirth] = useState([]);
  const [filteredFirstTeachers, setFilteredFirstTeachers] = useState([]);
  const [filteredSecondTeachers, setFilteredSecondTeachers] = useState([]);
  const { t } = useTranslation();
  const { createRegistrationInfo } = useRegistrationInfo(conditions);

  const flexibleDataValues = flexibleData?.[0]?.data_value || {};

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!addRegi.organization_path || addRegi.organization_path.length === 0) {
      alert(t("teacher.registrationInfo.alertSelectOrganization"));
      return;
    }

    if (!addRegi.school_year || addRegi.school_year.length === 0) {
      setAddRegi((addRegi) => ({ ...addRegi, school_year: schoolYear }));
      return;
    }

    const checkIfExistThisYear = allSortedRows.filter((r) => {
      return r.username === addRegi.username && r.school_year === schoolYear;
    });
    // console.log("allSortedRows", allSortedRows);

    // console.log("checkIfExistThisYear", checkIfExistThisYear);
    if (checkIfExistThisYear.length > 0) {
      alert(t("teacher.registrationInfo.alertNotSameStudent"));
      return;
    }

    // console.log("addRegi", addRegi);

    createRegistrationInfo.mutate(addRegi, {
      onSuccess: () => {
        setIsUpLoading(false);
        setIsSaving(true);
        setTimeout(() => {
          setIsSaving(false);
        }, 2000);
      },
      onError: (error) => {
        setIsUpLoading(false);
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error);
      },
    });
  };

  // 일반적인 검색 정규화: trim + lowercase
  const normalizeString = (str) => {
    if (!str) return "";
    return str.trim().toLowerCase();
  };

  const handleFullNameChange = (e) => {
    const { name, value } = e.target;
    const searchTerm = normalizeString(value);

    if (!searchTerm) {
      if (name === "student") setFilteredStudents([]);
      return;
    }

    const filtered = userData.filter((user) => {
      const userName = normalizeString(user.fullname);
      return (
        userName.includes(searchTerm) && user.role === name && user.status === 1
      );
    });

    if (name === "student") {
      setFilteredStudents(filtered);
    }
  };

  //{id: 1, fullname: "kim", hr_teacher_username: [{username: "hi@eduseed", tname:"이지아"},
  // {username: "hello@miraldure", tname: "유재석"}] }
  const handleInfoChange = (e) => {
    const { name, value } = e.target;

    setAddRegi((addRegi) => ({ ...addRegi, [name]: value }));
    // console.log("addRegi", addRegi);
    // console.log("filteredStudents", filteredStudents);
    // console.log("value", value);

    if (name === "username" && value !== null) {
      const thisUser = filteredStudents.find((r) => r.username === value);

      // const thisUser = filteredStudents.filter((r) => {
      //   console.log("r", r);
      //   return r.username === value;
      // });
      if (thisUser) {
        setGenderBirth([
          thisUser.gender?.length > 0 ? thisUser.gender : "",
          thisUser.birthday?.length > 0 ? thisUser.birthday : "",
        ]);
      } else {
        setGenderBirth(["", ""]);
      }
    }
  };

  const handleTeacherNameChange = (e) => {
    const { name, value } = e.target;
    if (!userData) return;

    const filtered = userData.filter((user) => {
      return (
        user.fullname.toLowerCase().includes(value.toLowerCase()) &&
        user.role === "teacher" &&
        user.status === 1
      );
    });

    if (name === "first_teacher_search") {
      setFilteredFirstTeachers(filtered);
    } else if (name === "second_teacher_search") {
      setFilteredSecondTeachers(filtered);
    }
  };

  // const handleClick = (hr_teacher) => {
  //   setAddRegi((addRegi) => ({
  //     ...addRegi,
  //     hr_teacher_username: addRegi.hr_teacher_username.filter(
  //       (user) => user.username !== hr_teacher
  //     ),
  //   }));
  //   // console.log("addRegi", addRegi);
  // };

  return (
    <form className="g-2" onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-5 col-sm-3 col-md-2">
          <label htmlFor="fullname" className="form-label ms-2  mb-0 fw-bold">
            {t("common.user.studentName") || "학생이름"}
            <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control m-2"
            name="student"
            required
            onChange={handleFullNameChange}
          />
        </div>

        <div className="col-6 col-sm-4 col-md-3">
          <label htmlFor="username" className="form-label ms-2  mb-0 fw-bold">
            {t("common.user.username") || "사용자계정"}
            <span style={{ color: "red" }}>*</span>
          </label>
          <select
            className="form-control m-2"
            name="username"
            required
            onChange={handleInfoChange}
          >
            <option value="">{t("common.labels.select") || "선택"}</option>
            {filteredStudents.map((user) => (
              <option key={user.id} value={user.username}>
                {user.username}
              </option>
            ))}
          </select>
        </div>

        <div className="col-3 col-sm-2 col-md-1 text-center">
          <label htmlFor="gender" className="form-label ms-2  mb-0 fw-bold">
            {t("common.user.gender") || "성별"}
          </label>
          <div className="m-1 mt-1 p-1">
            <span name="gender">{genderBirth && genderBirth[0]}</span>
          </div>
        </div>

        <div className="col-4 col-sm-3 col-md-2 text-center">
          <label htmlFor="birthday" className="form-label ms-2  mb-0 fw-bold">
            {t("common.user.birthday") || "생년월일"}
          </label>
          <div className="m-1 mt-1 p-1">
            <span name="birthday">{genderBirth && genderBirth[1]}</span>
          </div>
        </div>

        <div className="col-3 col-sm-3 col-md-2">
          <label htmlFor="studentno" className="form-label ms-2  mb-0 fw-bold">
            {t("common.user.studentNo")}
          </label>
          <input
            type="number"
            className="form-control m-2"
            name="studentno"
            onChange={handleInfoChange}
          />
        </div>
        <div className="col-1 col-sm-2 col-md-1">
          <label
            htmlFor="saveBtn"
            className="form-label ms-2  mb-0 fw-bold"
          ></label>
          <div>
            <button className="btn btn-primary text-nowrap mt-2">
              {isSaving
                ? t("common.labels.savedWell") || "저장완료"
                : t("common.labels.save") || "저장"}
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        {flexibleDataValues?.first_course && (
          <div className="col-4 col-sm-3 col-md-2">
            <label
              htmlFor="first_course"
              className="form-label ms-2  mb-0 fw-bold"
            >
              1학기 코스
            </label>
            <input
              type="text"
              className="form-control m-1"
              name="first_course"
              onChange={handleInfoChange}
            />
          </div>
        )}

        {flexibleDataValues?.first_course_teacher && (
          <>
            <div className="col-4 col-sm-3 col-md-2">
              <label
                htmlFor="first_teacher_search"
                className="form-label ms-2  mb-0 fw-bold"
              >
                1학기 담임 찾기
              </label>
              <input
                type="text"
                className="form-control m-1"
                name="first_teacher_search"
                placeholder="교사 이름 검색"
                onChange={handleTeacherNameChange}
              />
            </div>
            <div className="col-4 col-sm-3 col-md-2">
              <label
                htmlFor="first_course_teacher_username"
                className="form-label ms-2  mb-0 fw-bold"
              >
                1학기 담임 아이디
              </label>
              <select
                className="form-control m-1"
                name="first_course_teacher_username"
                onChange={handleInfoChange}
                value={addRegi.first_course_teacher_username || ""}
              >
                <option value="">선택</option>
                {filteredFirstTeachers.map((teacher) => (
                  <option key={teacher.id} value={teacher.username}>
                    {teacher.username}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}

        {flexibleDataValues?.second_course && (
          <div className="col-4 col-sm-3 col-md-2">
            <label
              htmlFor="second_course"
              className="form-label ms-2  mb-0 fw-bold"
            >
              2학기 코스
            </label>
            <input
              type="text"
              className="form-control m-1"
              name="second_course"
              onChange={handleInfoChange}
            />
          </div>
        )}

        {flexibleDataValues?.second_course_teacher && (
          <>
            <div className="col-4 col-sm-3 col-md-2">
              <label
                htmlFor="second_teacher_search"
                className="form-label ms-2  mb-0 fw-bold"
              >
                2학기 담임 찾기
              </label>
              <input
                type="text"
                className="form-control m-1"
                name="second_teacher_search"
                placeholder="교사 이름 검색"
                onChange={handleTeacherNameChange}
              />
            </div>
            <div className="col-4 col-sm-3 col-md-2">
              <label
                htmlFor="second_course_teacher_username"
                className="form-label ms-2  mb-0 fw-bold"
              >
                2학기 담임 아이디
              </label>
              <select
                className="form-control m-1"
                name="second_course_teacher_username"
                onChange={handleInfoChange}
                value={addRegi.second_course_teacher_username || ""}
              >
                <option value="">선택</option>
                {filteredSecondTeachers.map((teacher) => (
                  <option key={teacher.id} value={teacher.username}>
                    {teacher.username}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
      </div>
    </form>
  );
}

export default AddRegistration;
